var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureUnplag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3906 15.9883C15.6556 15.9883 10.9229 20.2852 10.2285 25.832H4.51562V28.6445H10.2286C10.9229 34.1913 15.6555 38.4883 21.3906 38.4883H22.7969C23.5759 38.4883 24.2031 37.8611 24.2031 37.082V34.2695H28.4219V31.457H24.2031V23.0195H28.4219V20.207H24.2031V17.3945C24.2031 16.6155 23.5759 15.9883 22.7969 15.9883H21.3906ZM41.0781 15.9883C40.2991 15.9883 39.6719 16.6155 39.6719 17.3945V20.207H42.4844V23.0195H39.6719V31.457H42.4844V34.2695H39.6719V37.082C39.6719 37.8611 40.2991 38.4883 41.0781 38.4883H49.5156V15.9883H41.0781Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78906 50.9688L50.7278 3.02999",
    stroke: "#8F4300",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureUnplag);
export default __webpack_public_path__ + "static/media/Feature_Unplag.37fed65247bf656eb41a1bad9294d2e9.svg";
export { ForwardRef as ReactComponent };